/** Shared WOW.js timing on the home page (aligned duration + stagger steps). */
export const HOME_WOW_DURATION = "0.65s";
export const HOME_WOW_STAGGER_MS = 80;

export function homeWowDelay(step: number): string {
  return `${((step * HOME_WOW_STAGGER_MS) / 1000).toFixed(2)}s`;
}
